import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

const state = {};

const getters = {};

const mutations = {};

const actions = {
    async enviarPromptIA(context, dados) {
        if (!JwtService.getToken()) throw new Error('Sessão indisponível.');
        ApiService.setHeader();
        const { data } = await ApiService.postOnce("ai/access/realizarPromptProntuarioCampo", dados, { timeout: 80000 });
        if(data?.CODIGO === 'IA_CREDITOS_INSUFICIENTES') {
            const error = new Error('Créditos de IA insuficientes. Adquira créditos para continuar. Seu texto foi preservado.');
            error.code = data.CODIGO;
            throw error;
        }
        if (data?.RESULTADO !== true || typeof data.RESPOSTA !== 'string' || !data.RESPOSTA.trim()) {
            throw new Error('Não foi possível processar o texto com IA.');
        }
        return data;
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};
